import React from 'react';

// INTERFACES
import { IBreadCrumbProps, IBreadCrumbContent } from '../../interfaces/BreadCrumb.interface';

// Styles
import BreadCrumbWrapper from './styles';

const BreadCrumb: React.FC<IBreadCrumbProps> = ({
  isWhite,
  activeIsBlack,
  breadCrumbContent,
  ...restProps
}: IBreadCrumbProps) => {
  return (
    <BreadCrumbWrapper isWhite={isWhite} activeIsBlack={activeIsBlack} {...restProps}>
      {breadCrumbContent.map(({ link: Link, name, icon }: IBreadCrumbContent, idx: number) => {
        return (
          <React.Fragment key={idx}>
            <Link>{icon || name}</Link>
            {breadCrumbContent.length - 1 != idx && <p>/</p>}
          </React.Fragment>
        );
      })}
    </BreadCrumbWrapper>
  );
};

export default BreadCrumb;
